import { useEffect, useState } from "react";
import { ChartLineUp } from "@phosphor-icons/react";
import { teleproApi } from "../../lib/teleproApi";
import PerformanceDashboard from "./PerformanceDashboard";

// VAGUE 43 — carte « Ma performance » sur le portail télépro.
export default function TeleproPerformanceCard() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (open && !data) teleproApi.get("/me/performance").then((r) => setData(r.data)).catch(() => setData({ error: true }));
  }, [open, data]);
  return (
    <section className="bg-card border border-border rounded-sm p-4 sm:p-5" data-testid="telepro-performance-card">
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between gap-2 text-left" data-testid="telepro-performance-toggle">
        <span className="flex items-center gap-2">
          <ChartLineUp size={16} weight="duotone" className="text-primary"/>
          <span className="font-display text-base font-medium">Ma performance — 7 et 30 jours</span>
        </span>
        <span className="text-xs font-semibold text-primary">{open ? "Masquer" : "Afficher"}</span>
      </button>
      {open && (
        <div className="mt-4">
          {!data ? <div className="text-sm text-muted-foreground">Chargement…</div>
            : data.error ? <div className="text-sm text-secondary">Statistiques indisponibles.</div>
            : <PerformanceDashboard data={data}/>}
        </div>
      )}
    </section>
  );
}
